import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { PROVIDER_EVENT_NAMES, tracking } from 'lib/segment/tracking'
import { EventLocations } from 'lib/segment/constants'
import { buildVisitEventProperties } from 'lib/segment/utils'

interface Params {
  isUpcomingVisit: boolean
  visitId: string
}

export function useTrackViewVisitNote({ isUpcomingVisit, visitId }: Params) {
  const [searchParams] = useSearchParams()
  const visit = useSelector((state: any) => state.chartsReducer.visitInfo[visitId])
  const hasTrackedRef = useRef(false)

  const ref = searchParams.get('ref')
  const properties = buildVisitEventProperties({
    visit,
    location: ref,
  })

  useEffect(() => {
    if (hasTrackedRef.current || !properties) {
      return
    }

    if (isUpcomingVisit) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      tracking.trackEvent(PROVIDER_EVENT_NAMES.VIEW_UPCOMING_VISIT_NOTE, properties)
    } else {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      tracking.trackEvent(PROVIDER_EVENT_NAMES.VIEW_PAST_VISIT_NOTE, properties)
    }

    hasTrackedRef.current = true
  }, [isUpcomingVisit, properties])
}

export function trackSaveVisitNote(visit: any) {
  const location = EventLocations.upcomingVisitNotes
  const properties = buildVisitEventProperties({ location, visit })

  if (!properties) {
    return
  }

  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  tracking.trackEvent(PROVIDER_EVENT_NAMES.SAVE_VISIT_NOTE, properties)
}
